// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reviews__bubble[data-v-b261cd24]{position:absolute;top:40px;left:-130px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
